import React from "react";
import { Row, Col } from "react-bootstrap";
import ResetForm from "./components/ResetForm";
import ResetImage from "./components/ResetImage";

const Email = () => {
  return (
    <>
      <div className="wrapper">
        <div className="h-100 vh-100">
          <Row>
            <Col lg={6}>
              <ResetForm />
            </Col>
            <Col lg={6}>
              <ResetImage />
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default Email;
